import GlobalErrorPage from '@components/common/GlobalErrorPage/GlobalErrorPage';
import { errorLogger } from '@utils/applicationLogUtils';
import React, { Component, ReactNode } from 'react';

interface ErrorBoundaryProps {
  children: ReactNode;
  hasError?: boolean; 
}

interface ErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    this.setState({ hasError: true });
    errorLogger(`ErrorBoundary caught an error: ${error} , ${errorInfo}`)
  }

  handleClose = () => {
    this.setState({ hasError: false });
    window.history.back();
  };

   handleGoToLandingPage = () => {
    this.setState({ hasError: false });
    window.location.href = '/landing-page';
  };

  render() {
    const { hasError: stateHasError } = this.state;  // From state

    const shouldShowFallback = stateHasError;

    if (this.state.hasError) {
      return (
        <GlobalErrorPage 
          onClose={this.handleClose} 
          handleGoToLandingPage={this.handleGoToLandingPage}
        />
      );
    }

    return this.props.children; 
  }
}

export default ErrorBoundary;
